// extracted by mini-css-extract-plugin
export default {"tileCardFile":"CardFileComponent_tileCardFile__r4mKq","railCardFile":"CardFileComponent_railCardFile__Ul295","emptyCardFile":"CardFileComponent_emptyCardFile__dUfy-"};